import React, { useEffect, useState } from 'react';
import {
  UserRound,
  ClipboardList,
  Bell,
  CreditCard,
  History,
  BotMessageSquare,
  HeartHandshake,
} from 'lucide-react';

const SidebarItems = {
  supplier: [
    {
      id: 1,
      name: 'My Projects',
      icon: <UserRound size={20} />,
      to: '/projects',
    },
    {
      id: 2,
      name: 'My Orders',
      icon: <ClipboardList size={20} />,
      to: '/orders',
    },
    {
      id: 3,
      name: 'Notifications',
      icon: <Bell size={20} />,
      to: '/notifications',
    },
    {
      id: 4,
      name: 'Payments',
      icon: <CreditCard size={20} />,
      to: '/payments',
    },
    {
      id: 5,
      name: 'Audit Trials',
      icon: <History size={20} />,
      to: '/audit-trails',
    },
    {
      id: 6,
      name: 'Chat Assistant',
      icon: <BotMessageSquare size={20} />,
      to: '/chat-assistant',
    },
    {
      id: 7,
      name: 'Support',
      icon: <HeartHandshake size={20} />,
      to: '/support',
    },
  ],
  buyer: [
    {
      id: 6,
      name: 'Chat Assistant',
      icon: <BotMessageSquare size={20} />,
      to: '/chat-assistant',
    },
    {
      id: 7,
      name: 'Support',
      icon: <HeartHandshake size={20} />,
      to: '/support',
    },
  ],
};

// Responsive Sidebar Component
const LeftSidebar = ({ isCompact = false, role = 'buyer' }) => {
  const [sidebar, setSidebar] = useState([]);

  useEffect(() => {
    setSidebar(SidebarItems[role] || []); // Fallback to an empty array if role is invalid
  }, [role]);
  return (
    <div
      className={`
      hidden
      md:flex md:flex-col
      font-roboto
      text-gray-600
      ${isCompact ? 'w-20' : 'w-52'}

      transition-all
      duration-300
      ease-in-out
      h-full
    `}
    >
      {sidebar.map((item) => (
        <div
          key={item.id}
          className={`
            flex
            items-center
            my-5
            cursor-pointer
            hover:text-darkerPurple
            ease-in-out
            duration-300
            ${isCompact ? 'justify-center' : ''}
          `}
          title={isCompact ? item.name : undefined}
        >
          {item.icon}
          {!isCompact && <span className="ml-3">{item.name}</span>}
        </div>
      ))}
    </div>
  );
};

export default LeftSidebar;
